import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/index/new-clue.svg'
import _imports_1 from '@/assets/index/new-business.svg'
import _imports_2 from '@/assets/index/new-visitor.svg'
import _imports_3 from '@/assets/index/new-follow.svg'
import _imports_4 from '@/assets/index/key-new-clue.svg'
import _imports_5 from '@/assets/index/key-new-business.svg'
import _imports_6 from '@/assets/index/key-new-visitor.svg'
import _imports_7 from '@/assets/index/key-new-follow.svg'


const _withScopeId = n => (_pushScopeId("data-v-b4051aa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = { class: "top-tab-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "top-tab-msg" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "top-tab-msg" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "top-tab-msg" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "top-tab-msg" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "key-data-box" }
const _hoisted_16 = { class: "top-label-from-box" }
const _hoisted_17 = { class: "from-box" }
const _hoisted_18 = { class: "key-data" }
const _hoisted_19 = { class: "data-box" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "data-msg" }
const _hoisted_22 = { style: {"color":"#877ced"} }
const _hoisted_23 = { class: "data-box" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "data-msg" }
const _hoisted_26 = { style: {"color":"#36c8e1"} }
const _hoisted_27 = { class: "data-box" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_29 = { class: "data-msg" }
const _hoisted_30 = { style: {"color":"#4ec690"} }
const _hoisted_31 = { class: "data-box" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_33 = { class: "data-msg" }
const _hoisted_34 = { style: {"color":"#ffb648"} }
const _hoisted_35 = { class: "out-box" }
const _hoisted_36 = { class: "out-box-task" }
const _hoisted_37 = { class: "top-label-from-box" }
const _hoisted_38 = { class: "from-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalSearch = _resolveComponent("GlobalSearch")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_HomeLeadOrUserBarChar = _resolveComponent("HomeLeadOrUserBarChar")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_HomeOpportunityFunnel = _resolveComponent("HomeOpportunityFunnel")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_periodic_follow_task = _resolveComponent("periodic-follow-task")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GlobalSearch, { type: "cos_ofbu" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "top-tab new-clue",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleRouterGo('/ofbu/salesClue/add')))
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.20hccb')), 1),
          (_ctx.language === 'zh-CN')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "LEADS"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "top-tab new-business",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleRouterGo('/ofbu/business/add')))
      }, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.lfxtck')), 1),
          (_ctx.language === 'zh-CN')
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "OPPORTUNITIES"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "top-tab new-visitor",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleRouterGo('/ofbu/visitorProgram/add')))
      }, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.k392xl')), 1),
          (_ctx.language === 'zh-CN')
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "VISITORS PROGRAM"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "top-tab new-follow",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleRouterGo('/ofbu/followUpRecord/add')))
      }, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.kfxcwn')), 1),
          (_ctx.language === 'zh-CN')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "FOLLOW-UP"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", null, _toDisplayString(_ctx.t('home.ae8swu')), 1),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_cos_range_picker, {
            startTime: _ctx.formState.keyData.startTime,
            "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.keyData.startTime) = $event)),
            endTime: _ctx.formState.keyData.endTime,
            "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.keyData.endTime) = $event))
          }, null, 8, ["startTime", "endTime"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('home.mxxg0x')), 1),
            _createElementVNode("span", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.clueCount || 0), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.t('home.qubyt3')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('home.pl479l')), 1),
            _createElementVNode("span", _hoisted_26, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.chanceCount || 0), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.t('home.qubyt3')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('home.375vnm')), 1),
            _createElementVNode("span", _hoisted_30, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.visitCount || 0), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.t('home.qubyt3')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('home.15v37b')), 1),
            _createElementVNode("span", _hoisted_34, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.followCount || 0), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.t('home.qubyt3')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeLeadOrUserBarChar, {
              appId: "cos_ofbu",
              type: "lead",
              isTimeZoneConv: "",
              isMultiLanguage: ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_Calendar, {
                appId: 'ofbu',
                isMultiLanguage: ""
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeLeadOrUserBarChar, {
              appId: "cos_ofbu",
              type: "user",
              isTimeZoneConv: "",
              isMultiLanguage: ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeOpportunityFunnel, {
              appId: "cos_ofbu",
              isTimeZoneConv: "",
              isMultiLanguage: ""
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("p", null, _toDisplayString(_ctx.t('home.m1sqzn')), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_a_date_picker, {
                    class: "input",
                    value: _ctx.formState.toConvertTask.month,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.toConvertTask.month) = $event)),
                    picker: "month",
                    allowClear: false
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_select, {
                    ref: "select",
                    class: "input",
                    value: _ctx.formState.toConvertTask.depCode,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.toConvertTask.depCode) = $event)),
                    style: {"width":"220px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "all" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('home.jio30c')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "my" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('home.dd13al')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _createVNode(_component_periodic_follow_task, { option: _ctx.readyChangeTask }, null, 8, ["option"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}